import classNames from 'classnames'
import React, { useEffect } from 'react'
import { animateScroll as scroll } from 'react-scroll'

import styles from './BackToTop.module.scss'

const BackToTop = ({ customLabel }) => {
  const isScrolledIntoView = (element, fullView) => {
    if (!element) return false

    const rect = element.getBoundingClientRect()

    let isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight
    if (!fullView) {
      isVisible = rect.top < window.innerHeight && rect.bottom >= 0
    }

    return isVisible
  }

  const scrollToTop = () => {
    scroll.scrollToTop()
  }

  const updateBackToTop = () => {
    const backToTopButton = document.getElementById('back-to-top')
    const footer = document.querySelector('footer')
    const MIN_HEIGHT = 300

    if (MIN_HEIGHT < window.scrollY) {
      backToTopButton.style.visibility = 'visible'
      backToTopButton.style.opacity = '1'
    } else {
      backToTopButton.style.visibility = 'hidden'
      backToTopButton.style.opacity = '0'
    }

    if (customLabel) {
      if (isScrolledIntoView(footer)) {
        backToTopButton.style.bottom =
          Math.round(window.innerHeight - footer.getBoundingClientRect().top) + 17 + 'px'
      } else {
        backToTopButton.style.bottom = '17px'
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', updateBackToTop)

    return () => {
      window.removeEventListener('scroll', updateBackToTop)
    }
  })

  return (
    <>
      <a
        id="back-to-top"
        onClick={scrollToTop}
        onKeyDown={scrollToTop}
        role="link"
        tabIndex={0}
        className={classNames(styles.backToTop, { [styles.noLabel]: !customLabel })}
      >
        {customLabel}
      </a>
    </>
  )
}

export default BackToTop
